import React from 'react'

import { Trans } from 'react-i18next'

import { OuterLink } from '~/shared/components/OuterLink'
import { AppLinks } from '~/shared/constants'
import { eventLogger } from '~/shared/services'

export const TermsOfUseLink: React.FC = () => (
  <OuterLink
    href={AppLinks.TOU_LINK}
    onClick={() => eventLogger.logTermsOfUseClicked()}
  >
    <Trans i18nKey="commonComponents.termsOfUse" />
  </OuterLink>
)
